import { Stimulus, Controller } from "#/layouts/js/stimulus"

const setChoiceGroups = () => {
  document.querySelectorAll(".choice-group").forEach(el => {
    const firstChoice = el.querySelector("div:first-child > select")
    const secondChoice = el.querySelector("div:last-child > select")

    secondChoice.disabled = firstChoice.value == ""

    if (firstChoice.value == "" || firstChoice.value == secondChoice.value) {
      secondChoice.value = ""
    }

    secondChoice.querySelectorAll("option").forEach(opt => {
      opt.disabled = opt.value != "" && opt.value == firstChoice.value
    })

    const firstDestroy = el.querySelector("div:first-child > input[name$='[_destroy]']")
    firstDestroy.value = firstChoice.value == "" ? 1 : 0

    const secondDestroy = el.querySelector("div:last-child > input[name$='[_destroy]']")
    secondDestroy.value = secondChoice.value == "" ? 1 : 0
  })
}

Stimulus.register("choices", class extends Controller {
  connect() {
    setChoiceGroups()
  }

  change() {
    setChoiceGroups()
  }
})
